import { render } from "./inputprojectshow.vue?vue&type=template&id=6c8277f4&scoped=true&ts=true"
import script from "./inputprojectshow.vue?vue&type=script&lang=ts"
export * from "./inputprojectshow.vue?vue&type=script&lang=ts"

import "./inputprojectshow.vue?vue&type=style&index=0&id=6c8277f4&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8277f4"]])

export default __exports__